import { notEmpty } from "@product/scmp-sdk";
import type { ReadonlyURLSearchParams } from "next/navigation";

import type { PlusDetailedListing } from "./types";

export const QueryParameterName = "plus-detail";
export const QuerySeparator = ":";

export function decodePlusDetailedListingQuery(
  searchParameters: ReadonlyURLSearchParams,
): PlusDetailedListing | undefined {
  const plusDetailQueryString = searchParameters.get(QueryParameterName) ?? "";
  const [type, entityUuid] = plusDetailQueryString.split(QuerySeparator).filter(notEmpty);

  switch (type) {
    case "author":
    case "daily-pulse":
    case "fact-sheet":
    case "quick-digest":
    case "topic":
      return { entityUuid, type };
  }
}

export function encodePlusDetailedListingQuery(plusDetailedListing: PlusDetailedListing): {
  [QueryParameterName]: string;
} {
  const { type: _type, ...rest } = plusDetailedListing;
  switch (plusDetailedListing.type) {
    case "fact-sheet":
    case "daily-pulse":
    case "quick-digest":
      return { [QueryParameterName]: plusDetailedListing.type, ...rest };
    case "author":
    case "topic":
      return {
        [QueryParameterName]: [plusDetailedListing.type, plusDetailedListing.entityUuid].join(
          QuerySeparator,
        ),
        ...rest,
      };
  }
}
